import { announcements, deletedeL } from "./noticeApi";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  dealDate,
  getBackTablesList,
  getCapitalLists,
  getTradeLists,
} from "../../course-manage/trade-manage/tradeMethods";
export const getUserLists = (data) => {
  let parame = {
    announcementName: data.userInput,
    schoolId: JSON.parse(sessionStorage.getItem("user")).schoolId,
    pageSize: data.pageSize,
    pageIndex: data.currentPage,
  };
  announcements(parame).then((res) => {
    if (res.data.code === "200") {
      let newRes = res.data.data;
      data.spreadTable = newRes.announcementVOList;
      data.total = newRes.total;
      dealDate(data.spreadTable, ["releaseTime"]);
      setTimeout(() => {
        data.loading = false;
      }, 300);
    }
  });
};

// 切换条数
export const sizeChanges = (val, data) => {
  data.pageSize = val;
  getUserLists(data);
};

// 切换页数
export const currentChanges = (val, data) => {
  data.currentPage = val;
  getUserLists(data);
};

export const delDrafrFiles = (item, data) => {
  let parame = {
    id: item.id,
  };
  deletedeL(parame).then((res) => {
    if (res.data.code === "200") {
      ElMessage.success(res.data.msg);
      getUserLists(data);
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

export const clickButtons = (val, data, router) => {
  if (val.type === "删除") {
    ElMessageBox.confirm("此操作将永久删除该报告, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      delDrafrFiles(val.item, data);
    });
  }
  if (val.type === "查看") {
    router.push({ path: "/index/checkNotice", query: { id: val.item.id } });
  }
};

// 切换 历史查找事件
export const DateChanges = (val, data) => {
  // data.pageSize = 10
  // data.currentPage = 1
  if (val === null) {
    data.startTime = undefined;
    data.endTime = undefined;
  } else {
    data.startTime = Date.parse(val[0]) / 1000;
    data.endTime = Date.parse(val[1]) / 1000;
  }
};
